import { render } from "./PrivatePromptsMain.vue?vue&type=template&id=cdaa87ae&scoped=true"
import script from "./PrivatePromptsMain.vue?vue&type=script&lang=js"
export * from "./PrivatePromptsMain.vue?vue&type=script&lang=js"

import "./PrivatePromptsMain.vue?vue&type=style&index=0&id=cdaa87ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdaa87ae"]])

export default __exports__